import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage    from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import HowItWorks from './components/HowItWorks';
import WhyWatrly from './components/WhyWatrly';
import Platform from './components/Platform';
import Scale from './components/Scale';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Admin App
import AdminApp from './admin';

// Tenant App
import TenantApp from './tenant';

// Customer App
import CustomerApp from './customer';

// Driver App
import DriverApp from './driver';

// Landing Page Component
const LandingPage = () => (
  <LanguageProvider>
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <WhyWatrly />
        <Platform />
        <Scale />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  </LanguageProvider>
);

function App() {
  // Check if we're on admin routes
  const isAdminRoute = window.location.pathname.startsWith('/admin');
  
  // Check if we're on tenant routes
  const isTenantRoute = window.location.pathname.startsWith('/tenant');

  // Check if we're on customer routes
  const isCustomerRoute = window.location.pathname.startsWith('/customer');

  // Check if we're on driver routes
  const isDriverRoute = window.location.pathname.startsWith('/driver');

  const isLoginRoute    = window.location.pathname === '/login';
  const isRegisterRoute  = window.location.pathname === '/register';

  if (isLoginRoute)    return <LoginPage />;
  if (isRegisterRoute) return <RegisterPage />;

  if (isAdminRoute) {
    return <AdminApp />;
  }

  if (isCustomerRoute) {
    return <CustomerApp />;
  }

  if (isTenantRoute) {
    return <TenantApp />;
  }

  if (isDriverRoute) {
    return <DriverApp />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
